import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { TaskServiceInterface } from "./definitions/task-service-interface";
import createMutation from "./mutations/create";
import { Observable } from "rxjs";
import { ErrorsInterface } from "../errors/errors-interface";
import { FetchResult } from '@apollo/client/core';

interface CreateTaskResponse {
  task: {
    create: {
      output: TaskServiceInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class TaskCreateService {
  constructor(private apollo: Apollo) {}

  create(task): Observable<FetchResult<CreateTaskResponse>> {
    return this.apollo.mutate<CreateTaskResponse>({
      mutation: createMutation,
      variables: task,
    });
  }
}
